import gql from 'graphql-tag';

const UPDATE_IS_BILLABLE = gql`
  mutation Mutation($deviceSerialNo: String!, $isBillable: Boolean!) {
    updateIsBillable(deviceSerialNo: $deviceSerialNo, isBillable: $isBillable) {
      code
      billingApplicableFrom
    }
  }
`;

export default UPDATE_IS_BILLABLE;
